import CountryCodeSelect from './CountryCodeSelect';

interface PhoneNumberDisplayProps {
  /** Country code value (e.g., '+964') */
  phoneCode: string;
  /** National phone number value */
  nationalPhone: string;
  /** Callback when country code changes */
  onPhoneCodeChange?: (value: string) => void;
  /** Callback when national phone changes */
  onNationalPhoneChange?: (value: string) => void;
  /** Disabled state for both inputs */
  disabled?: boolean;
  /** Read-only state (legacy support) */
  readOnly?: boolean;
  /** Error message to display */
  error?: string;
  /** Placeholder for phone input */
  placeholder?: string;
  /** Name attribute for phone input */
  name?: string;
  /** onBlur callback for phone input */
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
}

const PhoneNumberDisplay = ({
  phoneCode,
  nationalPhone,
  onPhoneCodeChange,
  onNationalPhoneChange,
  disabled = false,
  readOnly = false,
  error,
  placeholder,
  name,
  onBlur,
}: PhoneNumberDisplayProps) => {
  return (
    <div className='space-y-1.5'>
      <div className='flex gap-2' style={{ direction: 'ltr' }}>
        <CountryCodeSelect
          value={phoneCode}
          onChange={onPhoneCodeChange ?? (() => {})}
          disabled={disabled}
          readOnly={readOnly}
        />
        <input
          type='tel'
          name={name}
          value={nationalPhone || ''}
          disabled={disabled}
          readOnly={readOnly}
          onChange={
            disabled || readOnly ? undefined : (e) => onNationalPhoneChange?.(e.target.value)
          }
          onBlur={onBlur}
          placeholder={placeholder}
          className={`flex-1 h-10 px-3 rounded-lg border text-sm focus:outline-none ${
            disabled
              ? 'border-sd-input bg-sd-input-bg text-sd-muted-foreground cursor-not-allowed'
              : readOnly
                ? 'border-sd-input bg-sd-input-bg text-sd-foreground cursor-default'
                : `bg-sd-input-bg text-sd-foreground focus:ring-2 focus:ring-sd-ring ${
                    error ? 'border-red-500' : 'border-sd-input'
                  }`
          }`}
        />
      </div>
      {error && <p className='text-xs text-red-500'>{error}</p>}
    </div>
  );
};

export default PhoneNumberDisplay;
